/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const storeCityStyles: SxProps = {
	color:'black',
	minHeight: '210px',
	minWidth:'210px',
};


export const cityPageBackToWinkelSX: SxProps = {
	color:"#69baf8",
	fontWeight:700,
	marginBottom:'30px;',
	cursor:'pointer'
}

export const viewStoreSX: SxProps = {
	textDecoration:'underline',
	color:'#69baf8;',
	fontSize: '16px',
	display: 'flex',
	alignItems: 'center'
};

